// Theme-embedded click-id capture (alternative to Shopify Custom Web Pixel).
// Captures advertising click-IDs and clean UTM tags from the landing URL and
// writes them to Shopify cart attributes via /cart/update.js. The order
// webhook then promotes those attributes onto orders.fbclid / orders.gclid /
// etc. (see services/order_sync_service.py:_extract_click_ids).
//
// PII guard mirrors shopify_storefront/web_pixel/click_id_capture.js:
//   * reject values containing '@' or matching email regex
//   * cap values at 512 chars
//   * never write empty values

(function () {
  try {
    var CLICK_ID_KEYS = ['gclid','gbraid','wbraid','fbclid','ttclid','msclkid'];
    var UTM_KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
    var EMAIL_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;

    function isSafe(v) {
      return typeof v === 'string'
        && v.length > 0 && v.length <= 512
        && v.indexOf('@') === -1
        && !EMAIL_RE.test(v);
    }

    function readQuery() {
      try {
        var out = {};
        new URL(window.location.href).searchParams.forEach(function (val, key) {
          out[key] = val;
        });
        return out;
      } catch (_) {
        return {};
      }
    }

    function run() {
      var q = readQuery();
      var captured = {};
      CLICK_ID_KEYS.concat(UTM_KEYS).forEach(function (k) {
        if (q[k] && isSafe(q[k])) captured[k] = q[k];
      });
      if (Object.keys(captured).length === 0) return;

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          var existing = (cart && cart.attributes) || {};
          var toWrite = {};
          Object.keys(captured).forEach(function (k) {
            if (!existing[k]) toWrite[k] = captured[k];
          });
          if (Object.keys(toWrite).length === 0) return null;
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: toWrite }),
          });
        })
        .catch(function () { /* non-blocking */ });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  } catch (_) { /* never break the storefront */ }
})();
